"use client";

import {
  PARTNER_REVEAL_MOTION_CLASS,
  PARTNER_REVEAL_STAGGER_MS,
  partnerColumnRevealStyle,
} from "@/components/partners/partner-column-reveal";
import { ActionButton } from "@/components/ui/action-button";
import { useScrollAnimate } from "@/hooks/use-scroll-animate";
import Image from "next/image";

export function NationalMathStarsSection() {
  const imageAnimate = useScrollAnimate();
  const textAnimate = useScrollAnimate();

  return (
    <section className="bg-ink-900 text-white pt-2 md:pt-3 pb-0 relative overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-100">
        <Image
          src="/images/marketing/partners/nationalMathStars/background.webp"
          alt=""
          fill
          className="object-cover"
          aria-hidden="true"
        />
      </div>

      <div className="mx-auto px-3 sm:px-4 max-w-[1024px] relative z-10">
        <div className="flex flex-col md:flex-row items-center md:items-center gap-2 md:gap-3">
          {/* Left: Hero image — slides in from left */}
          <div
            ref={imageAnimate.ref}
            className={`w-full md:w-3/5 order-2 md:order-1 ${PARTNER_REVEAL_MOTION_CLASS}`}
            style={partnerColumnRevealStyle(imageAnimate.isVisible, "left")}
          >
            <div className="relative w-full">
              <Image
                src="/images/marketing/partners/nationalMathStars/hero.webp"
                alt="Student wearing National Math Stars t-shirt"
                width={500}
                height={600}
                className="w-full h-auto rounded-lg max-h-[400px] md:max-h-[500px] object-contain pt-6"
              />
            </div>
          </div>

          {/* Right: Logo, text, and button — slides in from right */}
          <div
            ref={textAnimate.ref}
            className={`w-full md:w-2/5 order-1 md:order-2 text-center md:text-left ${PARTNER_REVEAL_MOTION_CLASS}`}
            style={partnerColumnRevealStyle(textAnimate.isVisible, "right", {
              delayMs: PARTNER_REVEAL_STAGGER_MS,
            })}
          >
            <div className="pt-4 md:pt-0 mb-1">
              <Image
                src="/images/marketing/partners/nationalMathStars/logo.svg"
                alt="National Math Stars logo"
                width={80}
                height={80}
                className="inline-block h-[72px] md:h-20 w-auto"
              />
            </div>
            <p className="text-base md:text-lg text-gray-300 text-pretty mb-4">
              A free long-term support program for talented young math students. Kids join in grades
              2 or 3 and are supported by NMS through high school.
            </p>
            <ActionButton href="https://nationalmathstars.org/">Learn more!</ActionButton>
          </div>
        </div>
      </div>
    </section>
  );
}
